// @flow

import * as React from 'react';
import classNames from 'classnames';

import defaultAvatar from 'app/images/avatar_default.png';

type Organization = {
  +name: ?string,
  +iconUrl: ?string
};

type Props = {
  +organization: Organization,
  className?: string,
  style?: Object,
  suppressAltText?: boolean
};

export default class OrganizationAvatar extends React.PureComponent<Props> {
  render() {
    return (
      <img
        src={this.props.organization.iconUrl || defaultAvatar}
        className={classNames("rounded-relative", this.props.className)}
        alt={this.altText}
        title={this.altText}
        style={this.props.style}
      />
    );
  }

  get altText() {
    // return "";
    if (this.props.suppressAltText) {
      return "";
    }

    return this.props.organization.name;
  }
}
